import { gql } from "graphql-tag";
import { basePageableGraphqlField, responseField } from "../../../base.graphql";
import { buildingFields } from "../building/building.graphql";

// Define fields for building-zone
export const buildingZoneFields = `
    id
    uniqueId
    name
    bins {
                id
                uniqueId
                binNumber
                isActive
            }
   `;
const fewFields = `
    id
    uniqueId
    name
    numberOfSensors
    numberOfBins
`


export const warehouseBuilding = `
            id
            uniqueId
            name
            description
            totalCapacity
            availableCapacity
            isActive
            createdDate
`

// Queries
export const GET_ZONE_DATA = gql`
    query getAllZones($filtering:WarehouseZonesFilteringObject) {
    getAllZones(filtering: $filtering) {
        response {
            ${responseField}
        }
        data {
            ${buildingZoneFields}
        }
        page {
            ${basePageableGraphqlField}
        }
    }
}
`;

export const GET_ZONE_DATA_FEW_FIELDS = gql`
    query getAllZones($filtering:WarehouseZonesFilteringObject) {
    getAllZones(filtering: $filtering) {
        response {
            ${responseField}
        }
        data {
            ${fewFields}
        }
        page {
            ${basePageableGraphqlField}
        }
    }
}
`

export const GET_ZONE_DETAILS = gql`
    query getBuildingZoneDetails($id: ID!) {
        getBuildingZoneDetails(id: $id) {
            response {
                ${responseField}
            }
            data {
                ${buildingZoneFields}
            }
        }
    }`;

export const GET_ZONE_DASHBOARD = gql`
    query getBuildingZoneDashboard($filtering: BuildingZoneDashboardFilteringObject) {
        getBuildingZoneDashboard(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                totalZones
                activeZones
                inactiveZones
                zoneData {
                    ${buildingZoneFields}
                }
            }
        }
    }`;

export const GET_WAREHOUSES = gql`
  query GetWarehouseBuildings {
    getWarehouseBuildings(filtering: { pageNumber: 1 }) {
        response {
                ${responseField}
            }
        data {
            id
            uniqueId
            name
            description
            totalCapacity
            availableCapacity
            isActive
            createdDate
        }
        page {
            number
            hasNextPage
            hasPreviousPage
            nextPageNumber
            previousPageNumber
            numberOfPages
            totalItems
            pages
        }
    }
}
`;

// Mutations
export const REGISTER_ZONE_MUTATION = gql`
    mutation createWarehouseZonesMutation($input:WarehouseZonesInputObject!) {
        createWarehouseZonesMutation(
        input: $input
    ) {
        response {
           ${responseField}
        }
        data {
            id
            uniqueId
            name
        }
    }
}
`;

export const UPDATE_ZONE_MUTATION = gql`
    mutation updateWarehouseZonesMutation($input:WarehouseZonesInputObject!) {
        updateWarehouseZonesMutation(
        input: $input
    ) {
        response {
          ${responseField}
        }
        data {
           ${buildingZoneFields}
        }
    }
}
`;

export const DELETE_ZONE_MUTATION = gql`
    mutation deleteWarehouseZonesMutation($uniqueId:String!) {
        deleteWarehouseZonesMutation(uniqueId: $uniqueId) {
        response{${responseField}}
    }
}
`;

export const DELETE_ZONE_DATA = gql`
    mutation deleteBuildingZoneData($id: ID!) {
        deleteBuildingZoneData(id: $id) {
            response {
                ${responseField}
            }
        }
    }`;
